'use strict';

var angular = require('angular');


module.exports = angular
	.module('flxResetPassForm', [])
	.directive('flxResetPassForm', require('./flxResetPassFormDirective'))
	.controller('ResetFormCtrl', require('./flxResetPassFormController'));